

export const banglaContentDictionary = {
    topSearchPlaceholder: 'পণ্য খোঁজ করতে চাইলে (যেমন, গরুর মাংস, ছাগলের মাংস)',
    navItems : [
        {
            name: 'পণ্য',
            path: '/products',
            type: 'link'
        },
        {
            name: 'অফার',
            path: '/offer',
            type: 'link'
        },
        {
            name: 'রেসিপি',
            path: '/recipies',
            type: 'link'
        },
        {
            name: 'লগ ইন',
            path: '/login',
            type: 'link'
        },
        {
            name: 'ড্যাশবোর্ড',
            path: '/dashboard',
            type: 'link'
        },
        {
            name: 'লগ আউট',
            path: '/dashboard',
            type: 'button'
        }
    ]
};



export const englishContentDictionary = {
    topSearchPlaceholder: 'Search for products (e.g. cow meat, goat meat)',
    navItems : [
        {
            name: 'Products',
            path: '/products',
            type: 'link'
        },
        {
            name: 'Offer',
            path: '/offer',
            type: 'link'
        },
        {
            name: 'Recipies',
            path: '/recipies',
            type: 'link'
        },
        {
            name: 'Dashboard',
            path: '/dashboard',
            type: 'link'
        },
        {
            name: 'Logout',
            path: '/dashboard',
            type: 'button'
        }
    ]
};